// src/App.js
import React, { useContext, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import About from "./components/pages/About";
import Team from "./components/pages/Team";
import Home from "./components/services/Home";
import Header from "./components/common/Header";
import { AppProvider, AppContext } from "./context/AppContext";
import Footer from "./components/common/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/authentication/Login";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./css/Header.css";
import "./css/Home.css";
import Rents from "./components/services/Rents";
import Livings from "./components/services/Livings";
import Plots from "./components/services/Plots";
import Commercials from "./components/services/Commercials";
import PropertyList from "./components/property/PropertyList";
import PropertyDetail from "./components/property/PropertyDetail";
import EMICalculator from "./components/calculator/EMICalculator";
import Profile from "./components/profile/Profile";
import Purchase from "./components/Purchase";
import MyTransactions from "./components/profile/MyTransactions";
import MyMessages from "./components/profile/MyMessages";
import MyReviews from "./components/profile/MyReviews";
import MyActivity from "./components/profile/MyActivity";
import PropertyListLocality from "./components/property/PropertyListLocality";
import MyListing from "./components/profile/MyListing";
import ResidentialSell from "./components/ResidentialSell";
import ResidentialRent from "./components/ResidentialRent";
import ProfileEdit from "./components/profile/ProfileEdit";
import ContactProperty from "./components/property/ContactProperty";
import ViewProperty from "./components/property/ViewProperty";
import ShortlistProperty from "./components/property/ShortlistProperty";
import ResidentialPg from "./components/ResidentialPg";
import CommercialRent from "./components/CommercialRent";
import CommercialSell from "./components/CommercialSell";
import PackagePage from "./components/PackagePage";
import OrderReview from "./components/OrderReview";
import PostProperty from "./components/postProperty/PostProperty";
import AdditionalDetails from "./components/AdditionalDetails";
import AdvancedDetails from "./components/AdvancedDetails";
import VerifyProperty from "./components/property/VerifyProperty";
import ManagePlan from "./components/profile/ManagePlan";
import AOS from "aos";
import "aos/dist/aos.css";
import PopUp from "./components/PopUp";
import MyProfile from "./components/profile/MyProfile";
import Procedures from "./components/common/Procedures";
import ContactUs from "./components/pages/ContactUs";
import Blogs from "./components/pages/Blogs";
import BlogsPost from "./components/pages/BlogsPost";
import Faq from "./components/faq/Faq";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import TermCondition from "./components/pages/TermCondition";
import ScrollToTop from "./components/ScrollToTop";
import PropertyListPg from "./components/property/PropertyListPg";
import AddProject from "./components/project/AddProject";
import PropertyValuation from "./components/valuation/PropertyValuation";
import MyProjects from "./components/profile/MyProjects";
import MyListings from "./components/profile/MyListings";
import LegalAdvice from "./components/LegalAdvice";
import HomeLoan from "./components/HomeLoan";
import OurService from "./components/OurService";
import ConfirmationModal from "./components/modals/ConfirmationModal";
import NotFound from "./components/errorPage/NotFound";
import axios from "axios";
import LaunchWaitingScreen from "./components/LaunchWaitingScreen";
import BackToTop from "./components/common/BackToTop";
import HeaderNew from "./components/common/HeaderNew";
import NewAbout from "./components/pages/NewAbout";
import NewHome from "./components/services/NewHome";
import Career from "./components/pages/Career";

function InitialRedirectHandler({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkShortCode = async () => {
      const pathSegments = location.pathname.split("/").filter(Boolean);
      if (pathSegments.length === 0) {
        setChecking(false);
        return;
      }

      const lastSegment = pathSegments[pathSegments.length - 1];

      if (
        /^[a-zA-Z0-9]{6}$/.test(lastSegment) &&
        lastSegment.toLowerCase() !== "living"
      ) {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/get/fullUrl`,
            { short_code: lastSegment }
          );

          if (response.data?.original_url) {
            window.location.href = response.data.original_url;
          } else {
            navigate("/not_found");
          }
        } catch (err) {
          console.error("Error checking short URL:", err);
          navigate("/not_found");
        }
      } else {
        // No short code detected, allow normal routes
        setChecking(false);
      }
    };

    setChecking(true);
    checkShortCode();
  }, [location.pathname, navigate]);

  if (checking) {
    // Render a loading UI while checking the short code
    return <div></div>;
  }

  return children;
}

function MainApp() {
  const { theme, isAuthenticated } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, [location]);

  //  const now = new Date();
  // const isBeforeLaunch =
  //   now.getHours() < 6 || (now.getHours() === 6 && now.getMinutes() < 15);

  // if (isBeforeLaunch) {
  //   return <LaunchWaitingScreen />;
  // }
  return (
    <div
      style={{
        backgroundColor: theme === "light" ? "rgba(244, 244, 244, 1)" : "#333",
        color: theme === "light" ? "#000" : "#fff",
      }}
    >
      {/* <Header /> */}
      <HeaderNew />
      <BackToTop />
      <Routes>
        {/* <Route path="/:slug" element={<NewHome />} /> */}
        <Route path="/:slug" element={<Plots />} />
        {/* <Route path="/buy" element={<NewHome />} /> */}
        <Route path="/buy/:slug" element={<NewHome />} />
        {/* <Route path="/" element={<NewHome />} /> */}
        <Route path="/" element={<Plots />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/commercial" element={<Commercials />} /> */}
        <Route path="/commercial/:slug" element={<Commercials />} />
        <Route path="/rent/:slug" element={<Rents />} />
        <Route path="/rent" element={<Rents />} />
        <Route path="/emi" element={<EMICalculator />} />
         <Route path="/career_page" element={<Career />} />
        <Route path="/propertyDetail" element={<PropertyDetail />} />
        <Route path="/propertyList" element={<PropertyList />} />
        <Route path="/packagePage" element={<PackagePage />} />
        <Route path="/managePlan" element={<ManagePlan />} />
        <Route path="/myListing" element={<MyListing />} />
        <Route path="my-listings/new/basic" element={<MyListing />} />
        <Route path="residentialRent" element={<ResidentialRent />} />
        <Route path="residentialSell" element={<ResidentialSell />} />
        <Route path="residentialPg" element={<ResidentialPg />} />
        <Route path="commercialRent" element={<CommercialRent />} />
        <Route path="commercialSell" element={<CommercialSell />} />
        <Route path="/contactProperty" element={<ContactProperty />} />
        <Route path="/viewProperty" element={<ViewProperty />} />
        <Route path="/shortlistProperty" element={<ShortlistProperty />} />
        {/* <Route path="/commercialAdd" element={<CommercialAdd />} /> */}
        <Route path="/living/:slug" element={<Livings />} />
        <Route path="/living" element={<Livings />} />
        <Route path="/plot/:slug" element={<Plots />} />
        {/* <Route path="/living" element={<Livings />} /> */}
        {/* <Route path="/plot" element={<Plots />} /> */}
        <Route path="/about" element={<About />} />
        <Route path="/:type/:slug" element={<PropertyDetail />} />
        <Route path="/team" element={<Team />} />
        {/* <Route path="/:slug" element={<PropertyDetail />} /> */}
        <Route
          path="/buy/searches/:locality"
          element={<PropertyListLocality />}
        />
        <Route
          path="/living/searches/:locality"
          element={<PropertyListLocality />}
        />
        {/* <Route path="/rent/searches/:locality" element={<PropertyListRentResidential />} /> */}
        <Route
          path="/rent/searches/:locality"
          element={<PropertyListLocality />}
        />
        {/* <Route path="/commercial/lease/searches/:locality" element={<PropertyListLeaseCommerical />} /> */}
        <Route
          path="/commercial/lease/searches/:locality"
          element={<PropertyListLocality />}
        />
        {/* <Route path="/commercial/sell/searches/:locality" element={<PropertyListBuyCommercial />} /> */}
        {/* <Route path="/commercial/buy/searches/:locality" element={<PropertyListBuyCommercial />} /> */}
        <Route
          path="/commercial/buy/searches/:locality"
          element={<PropertyListLocality />}
        />
        {/* <Route path="/plot/searches/:locality" element={<PropertyListBuyPlot />} /> */}
        <Route
          path="/plot/searches/:locality"
          element={<PropertyListLocality />}
        />
        <Route path="/pg/searches/:locality" element={<PropertyListPg />} />

        <Route path="/orderReview" element={<OrderReview />} />
        <Route path="/addProject" element={<AddProject />} />
        <Route path="/myProjects" element={<MyProjects />} />
        <Route path="/myListings" element={<MyListings />} />

        <Route path="/procedures" element={<Procedures />} />
        <Route path="/aboutUs" element={<NewAbout />} />
        <Route path="/team" element={<Team />} />
       
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/:contentType/:categorys/:slug" element={<BlogsPost />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/term_condition" element={<TermCondition />} />
        <Route path="/not_found" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />

        <Route path="/myListings/:propertyId" element={<AdditionalDetails />} />
        <Route path="/advancedDetails" element={<AdvancedDetails />} />
        <Route path="/verifyProperty" element={<VerifyProperty />} />
        <Route path="/popUp" element={<PopUp />} />
        <Route path="/legalAdvice" element={<LegalAdvice />} />
        <Route path="/homeLoan" element={<HomeLoan />} />
        <Route path="/ourService" element={<OurService />} />
        {/* <Route path="/confirm" element={<ConfirmationModal/>}/> */}

        <Route
          path="/propertyValuation"
          element={<ProtectedRoute element={<PropertyValuation />} />}
        />
        <Route
          path="/profile"
          element={<ProtectedRoute element={<Profile />} />}
        />
        <Route
          path="/purchase"
          element={<ProtectedRoute element={<Purchase />} />}
        />
        <Route
          path="/myTransactions"
          element={<ProtectedRoute element={<MyTransactions />} />}
        />
        <Route
          path="/myMessages"
          element={<ProtectedRoute element={<MyMessages />} />}
        />
        <Route
          path="/myReviews"
          element={<ProtectedRoute element={<MyReviews />} />}
        />
        <Route
          path="/myActivity"
          element={<ProtectedRoute element={<MyActivity />} />}
        />
        <Route
          path="/myProfile"
          element={<ProtectedRoute element={<MyProfile />} />}
        />
        <Route
          path="/profileEdit"
          element={<ProtectedRoute element={<ProfileEdit />} />}
        />
        <Route
          path="/postProperty"
          element={<ProtectedRoute element={<PostProperty />} />}
        />
        <Route
          path="/myListing/:listingId"
          element={<ProtectedRoute element={<PostProperty />} />}
        />
        <Route
          path="/myProject/:projectId"
          element={<ProtectedRoute element={<AddProject />} />}
        />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  useEffect(() => {
    setTimeout(() => {
      AOS.init({ duration: 500, once: false });
    }, 500);
  }, []);

  // const now = new Date();
  // const launchTime = new Date();
  // launchTime.setHours(18); // 6 PM
  // launchTime.setMinutes(15); // 15 minutes
  // launchTime.setSeconds(0);
  // launchTime.setMilliseconds(0);

  // const isBeforeLaunch = now < launchTime;

  // if (isBeforeLaunch) {
  //   return <LaunchWaitingScreen />;
  // }
  return (
    <AppProvider>
      <Router>
        <ScrollToTop />
        <InitialRedirectHandler>
          <MainApp />
        </InitialRedirectHandler>
      </Router>
    </AppProvider>
  );
}

export default App;
